export const GET_ORDER_SETTINGS_API = "/shop/settings/";
export const UPDATE_ORDER_SETTINGS_API = "/shop/settings/";

export const GET_ORDER_SHIFTS_API = "/shop/shifts/";
export const ADD_ORDER_SHIFT_API = "/shop/shifts/";
export const DELETE_ORDER_SHIFT_API = "/shop/shifts/";
export const UPDATE_ORDER_SHIFT_API = "/shop/shifts/";

export const GET_ORDER_PRODUCTS_API = "/shop/products/";
export const ADD_ORDER_PRODUCT_API = "/shop/products/";
export const DELETE_ORDER_PRODUCT_API = "/shop/products/";
export const UPDATE_ORDER_PRODUCT_API = "/shop/products/";

export const GET_NEW_ORDERS_API = "/shop/new-orders/";
export const GET_ORDERS_API = "/shop/orders/";
export const GET_PAST_ORDERS_API = "/shop/past-orders/";
export const UPDATE_ORDER_API = "/shop/orders/";
export const MARK_AS_READ_ORDER_API = "/shop/orders/";

export const ACTIVATE_STRIPE_API = "/shop/activate-stripe/";
export const DEACTIVATE_STRIPE_API = "/shop/deactivate-stripe/";


// WEBPACK FOOTER //
// ./src/apis/orders.js